import { render } from "./pharmacydelete.vue?vue&type=template&id=27d47e42"
import script from "./pharmacydelete.vue?vue&type=script&lang=js"
export * from "./pharmacydelete.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__